

$(function(){


    $("#acceptCookies").on('click', function(){

        $.ajax({
            url      : "/cookies/consent",
            method   : "POST",
            dataType : "json",
            data     : jQuery.param({ status: "accepted" })
        });

    });


    $("#declineCookies").on('click', function(){

        $.ajax({
            url      : "/cookies/consent",
            method   : "POST",
            dataType : "json",
            data     : jQuery.param({ status: "declined" })
        });

    });


});